import ExpensifyApprovedLogo from '@assets/images/subscription-details__approvedlogo--light.svg';
import EmptyStateBackgroundImage from '@assets/images/themeDependent/empty-state_background-fade-light.png';
import ExampleCheckEN from '@assets/images/themeDependent/example-check-image-light-en.png';
import ExampleCheckES from '@assets/images/themeDependent/example-check-image-light-es.png';
import WorkspaceProfile from '@assets/images/workspace-profile-light.png';
import type IllustrationsType from '@styles/theme/illustrations/types';

const illustrations = {
    EmptyStateBackgroundImage,
    ExampleCheckEN,
    ExampleCheckES,
    WorkspaceProfile,
    ExpensifyApprovedLogo,
} satisfies IllustrationsType;

export default illustrations;
